import { render, staticRenderFns } from "./moveOrder.vue?vue&type=template&id=1fbca21e&scoped=true&"
import script from "./moveOrder.vue?vue&type=script&lang=js&"
export * from "./moveOrder.vue?vue&type=script&lang=js&"
import style0 from "./moveOrder.vue?vue&type=style&index=0&id=1fbca21e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbca21e",
  null
  
)

export default component.exports